var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08334 4H11.5833C12.2276 4 12.75 4.52233 12.75 5.16666V5.75004H14.4999C15.1442 5.75004 15.6666 6.27237 15.6666 6.91669V8.08335C15.6666 8.72768 15.1442 9.25001 14.4999 9.25001H14.4532L13.9166 15.6666C13.9166 16.311 13.3943 16.8333 12.75 16.8333H6.9167C6.27237 16.8333 5.75004 16.311 5.75206 15.7151L5.2133 9.25001H5.16666C4.52233 9.25001 4 8.72768 4 8.08335V6.91669C4 6.27237 4.52233 5.75004 5.16666 5.75004H6.91669V5.16666C6.91669 4.52233 7.43901 4 8.08334 4ZM13.2827 9.25001H6.38388L6.91675 15.6666H12.75L12.752 15.6181L13.2827 9.25001ZM5.16666 8.08338V6.91672H14.4999V8.08338H5.16666ZM11.5833 5.16665V5.74997H8.08335V5.16665H11.5833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.732905b3.svg";
export { ForwardRef as ReactComponent };